import { useMemo, useState } from "react";
import styled, { css } from "styled-components";

export default function JSONInput(props) {
    const { onChange, value } = props;

    const [text, setText] = useState<string>(
        () => JSON.stringify(value, undefined, 2),
    );

    function handleChange(event) {
        const next = event.target.value;
        setText(next);
        try {
            onChange(JSON.parse(next));
        } catch {
            // mid-edit text is often not valid JSON yet; keep the last parsed value
        }
    }

    const valid = useMemo(
        () => {
            try {
                JSON.parse(text);
                return true;
            } catch {
                return false;
            }
        },
        [text],
    );

    return (
        <Styled
            $valid={ valid }
            onChange={ handleChange }
            value={ text }
        />
    );
}

const CSSInvalidJSON = css`
    outline: 2px solid red;
`;

const Styled = styled.textarea<{ $valid: boolean }>`
    background: transparent;
    border: 1px solid #0002;
    border-radius: 4px;
    outline: none transparent;
    padding: 8px;
    transition: 200ms outline-color;

    &:focus {
        outline: 2px solid royalblue;
        outline-offset: -1px;
    }

    &::placeholder {
        color: #0005;
    }

    ${ ({ $valid }) => !$valid && CSSInvalidJSON };
`;
